export default __webpack_public_path__ + "static/media/modal-image.008830d7.jpg";